import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=65ed2f37&scoped=true"
import script from "./goodDetail.vue?vue&type=script&lang=ts"
export * from "./goodDetail.vue?vue&type=script&lang=ts"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=65ed2f37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed2f37",
  null
  
)

export default component.exports